/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '.././theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System Error Icon component.
 */
export const SystemErrorIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  const stroke = props?.stroke || dlsColor('white');
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12 7V13.3792'
        stroke={stroke}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d='M12 14.5273V16.2909'
        stroke={stroke}
        strokeMiterlimit={10}
        strokeWidth={1.5} />
      <circle cx='12' cy='12' r='10' stroke={iconColor} strokeWidth={1.5} />
    </svg>
  );
};
